import "./ContactUs.css";
import "./theme.css";
import { useEffect } from "react";
import { FiMapPin, FiMail, FiPhone, FiArrowUpRight } from "react-icons/fi";

const EMAIL = "contact@parivikshak.in";
const PHONE_DISPLAY = "+91 94820 31400";
const PHONE_LINK = "+919482031400";

export default function ContactUs() {
  useEffect(() => {
    const savedTheme = localStorage.getItem("theme") || "light";
    document.documentElement.setAttribute("data-theme", savedTheme);
  }, []);

  return (
    <main className="contact-page">
      <section className="contact-creative">
        <div className="contact-creative-shell">
          <div className="contact-layout">
            {/* ---------------- left: copy + contact cards ---------------- */}
            <div className="contact-copy">
              <div className="contact-eyebrow">GET IN TOUCH</div>

              <h1>
                Building
                <br />a Safer Tomorrow
                <span>Together.</span>
              </h1>

              <p className="contact-lead">
                Connect with our team for product demos, support, partnerships
                or any other enquiry. Whether you are exploring digital safety
                management for the first time or looking to improve an existing
                process, our team is ready to help.
              </p>

              <div className="contact-help">
                <div className="contact-help-heading">
                  <span>HOW WE CAN HELP</span>
                  <div />
                </div>

                <div className="contact-help-grid">
                  <div className="contact-help-item">
                    <div className="contact-help-icon">
                      <FiArrowUpRight />
                    </div>
                    <div>
                      <strong>Product Demo</strong>
                      <span>Explore Parivikshak and its safety workflows.</span>
                    </div>
                  </div>

                  <div className="contact-help-item">
                    <div className="contact-help-icon">
                      <FiArrowUpRight />
                    </div>
                    <div>
                      <strong>Implementation Support</strong>
                      <span>Discuss deployment, onboarding and adoption.</span>
                    </div>
                  </div>

                  <div className="contact-help-item">
                    <div className="contact-help-icon">
                      <FiArrowUpRight />
                    </div>
                    <div>
                      <strong>Partnerships</strong>
                      <span>
                        Talk to us about collaboration and opportunities.
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="contact-cards">
                <article className="contact-card">
                  <div className="contact-card-icon">
                    <FiMapPin />
                  </div>
                  <h3>Office Address</h3>
                  <p>
                    Parivikshak
                    <br />
                    202/A-2/A, Atri Nandan,
                    <br />
                    2nd Floor, Shukrawar Peth
                    <br />
                    Belagavi – 590006
                    <br />
                    Karnataka, India
                  </p>
                </article>

                <article className="contact-card">
                  <div className="contact-card-icon">
                    <FiMail />
                  </div>
                  <h3>Email</h3>
                  <p>
                    <a href={`mailto:${EMAIL}`}>{EMAIL}</a>
                  </p>
                </article>

                <article className="contact-card">
                  <div className="contact-card-icon">
                    <FiPhone />
                  </div>
                  <h3>Phone</h3>
                  <p>
                    <a
                      className="contact-card-strong"
                      href={`tel:${PHONE_LINK}`}
                    >
                      {PHONE_DISPLAY}
                    </a>
                    <br />
                    Mon – Sat
                    <br />
                    9:00 AM – 6:00 PM IST
                  </p>
                </article>
              </div>

              <div className="contact-status">
                <span />
                <strong>
                  We&apos;re available to help with your safety transformation.
                </strong>
                <em>Mon – Sat · 9:00 AM – 6:00 PM IST</em>
              </div>
            </div>

            {/* ---------------- right: illustration ---------------- */}
            <div className="contact-visual">
              <div className="visual-blob" />
              <div className="visual-dots" />

              <div
                className="visual-photo"
                role="img"
                aria-label="Parivikshak office building"
              />

              <div className="visual-map">
                <iframe
                  title="Parivikshak Location"
                  src="https://maps.google.com/maps?q=15.837520,74.502223&z=17&output=embed"
                  loading="lazy"
                  allowFullScreen
                />

                <div className="visual-pin">
                  <FiMapPin />
                  <div>
                    <strong>Parivikshak</strong>
                    <span>Belagavi, Karnataka · 590006</span>
                  </div>
                </div>
              </div>

              <div className="visual-badge">
                COMPANY LOCATION
                <span />
              </div>

              <a
                className="visual-arrow"
                href={`mailto:${EMAIL}`}
                aria-label="Email us"
              >
                <FiArrowUpRight />
              </a>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
